var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_1",
    "data-name": "Component 19 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 371,
    height: 130.641,
    viewBox: "0 0 371 130.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.384,
    y1: 0.154,
    x2: 0.616,
    y2: 0.846,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#350dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c61ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.205,
    y1: 0.236,
    x2: 0.795,
    y2: 0.764,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 27.929,
    y1: 12.65,
    x2: 29.382,
    y2: 12.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.044,
    y1: 0.013,
    x2: 1.044,
    y2: 0.987,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 10.047,
    y1: -17.009,
    x2: 11.501,
    y2: -17.009,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tykhere_Logo_H"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2917",
    "data-name": "Group 2917",
    transform: "translate(159.656 36.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2916",
    "data-name": "Group 2916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2914",
    "data-name": "Group 2914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17621",
    "data-name": "Path 17621",
    d: "M392.078,168.228a3.405,3.405,0,0,1-3.516,3.346,13.647,13.647,0,0,1-1.522-.057,8.646,8.646,0,0,1-5.158-2.511,8.012,8.012,0,0,1-1.994-5.021V149.92h-2.522a3.353,3.353,0,1,1,0-6.7h2.522V132.561a3.52,3.52,0,0,1,7.032,0v10.662h1.931a3.353,3.353,0,1,1,0,6.7H386.92V163.2c.119.449,0,1.113.409,1.454.3.278.818.221,1.233.221A3.454,3.454,0,0,1,392.078,168.228Z",
    transform: "translate(-373.85 -129.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M443.207,158.516v24.391a14.452,14.452,0,0,1-25.306,9.208,3.345,3.345,0,0,1,.352-4.743,3.388,3.388,0,0,1,4.805.392,7.8,7.8,0,0,0,5.743,2.567,7.517,7.517,0,0,0,7.555-7.424v-2.289a13.884,13.884,0,0,1-6.68,1.732,13.588,13.588,0,0,1-13.417-13.729v-9.992a3.4,3.4,0,0,1,6.794,0v9.992a6.662,6.662,0,1,0,13.3,0v-10.1a3.426,3.426,0,0,1,6.85-.006Z",
    transform: "translate(-392.17 -140.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M500.726,170.881a3.93,3.93,0,0,1-2.636,1.062,3.56,3.56,0,0,1-2.4-.892l-11.951-10.491v8.316a3.577,3.577,0,0,1-7.146,0V133.322a3.577,3.577,0,0,1,7.146,0v18.864l11.542-7.589a3.68,3.68,0,0,1,4.982.835,3.3,3.3,0,0,1-.818,4.743l-9.781,6.305,10.895,9.543A3.375,3.375,0,0,1,500.726,170.881Z",
    transform: "translate(-418.231 -129.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17624",
    "data-name": "Path 17624",
    d: "M555.29,168.827a3.55,3.55,0,0,1-7.089,0V156.6a6.04,6.04,0,0,0-12.065,0v12.224a3.461,3.461,0,0,1-3.573,3.351,3.5,3.5,0,0,1-3.573-3.351v-35.6a3.544,3.544,0,0,1,3.573-3.4,3.5,3.5,0,0,1,3.573,3.4V145.5a13.671,13.671,0,0,1,6.033-1.4c7.265,0,13.121,5.584,13.121,12.5Z",
    transform: "translate(-440.866 -129.473)",
    fill: "#350dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17625",
    "data-name": "Path 17625",
    d: "M610.867,170.8H592.827a7.645,7.645,0,0,0,7.441,5.635,10.131,10.131,0,0,0,6.152-2.119,3.644,3.644,0,0,1,4.982.057,3.2,3.2,0,0,1-.057,4.743,16.79,16.79,0,0,1-11.071,3.965c-8.145,0-14.644-6.248-14.644-14.008,0-7.646,6.5-14.008,14.644-14.008a13.638,13.638,0,0,1,2.579.222,14.179,14.179,0,0,1,9.492,6.419c.937,1.562,1.994,3.63,1.874,5.47a4.571,4.571,0,0,1-.466,1.619A3.208,3.208,0,0,1,610.867,170.8Zm-17.047-5.635h12.423a6.577,6.577,0,0,0-5.975-3.351A7.718,7.718,0,0,0,593.821,165.17Z",
    transform: "translate(-465.333 -140.381)",
    fill: "#350dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17626",
    "data-name": "Path 17626",
    d: "M669.871,163.36a3.645,3.645,0,0,1-4.982.165,7.287,7.287,0,0,0-12.127,5.357v10.548a3.52,3.52,0,0,1-7.032,0V158.055a3.4,3.4,0,0,1,3.516-3.295,3.478,3.478,0,0,1,3.34,2.289,14.68,14.68,0,0,1,7.441-2.068,14.515,14.515,0,0,1,9.668,3.681A3.184,3.184,0,0,1,669.871,163.36Z",
    transform: "translate(-491.294 -140.247)",
    fill: "#350dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17627",
    "data-name": "Path 17627",
    d: "M720.813,170.8H702.767a7.645,7.645,0,0,0,7.441,5.635,10.131,10.131,0,0,0,6.152-2.119,3.644,3.644,0,0,1,4.982.057,3.2,3.2,0,0,1-.057,4.743,16.79,16.79,0,0,1-11.071,3.965c-8.146,0-14.644-6.248-14.644-14.008,0-7.646,6.5-14.008,14.644-14.008a13.637,13.637,0,0,1,2.579.222,14.179,14.179,0,0,1,9.492,6.419c.937,1.562,1.994,3.63,1.875,5.47a4.569,4.569,0,0,1-.466,1.619A3.193,3.193,0,0,1,720.813,170.8Zm-17.047-5.635H716.19a6.578,6.578,0,0,0-5.976-3.351A7.719,7.719,0,0,0,703.767,165.17Z",
    transform: "translate(-512.824 -140.381)",
    fill: "#350dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2915",
    "data-name": "Group 2915",
    transform: "translate(0.392 62.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17628",
    "data-name": "Path 17628",
    d: "M379.681,239.815a.69.69,0,0,1-.108.432.4.4,0,0,1-.329.136h-1.517v6.14h-1.272v-6.14H374.54v-.943h5.1A2.2,2.2,0,0,1,379.681,239.815Z",
    transform: "translate(-374.54 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17629",
    "data-name": "Path 17629",
    d: "M398.782,245.6a1.6,1.6,0,0,1-.114.727.431.431,0,0,1-.415.193H394.34V239.44H398.7v.92h-3.084v2.062h2.6v.909h-2.6V245.6h3.164Z",
    transform: "translate(-383.093 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17630",
    "data-name": "Path 17630",
    d: "M414.744,246.345a2.049,2.049,0,0,1-.92-.562,1.23,1.23,0,0,1-.324-.841.569.569,0,0,1,.25-.488,1.257,1.257,0,0,1,.693-.182,1.432,1.432,0,0,0,.534.971,1.878,1.878,0,0,0,1.176.341,1.793,1.793,0,0,0,1.079-.284.942.942,0,0,0,.381-.807.821.821,0,0,0-.369-.693,4.241,4.241,0,0,0-1.3-.523,4.44,4.44,0,0,1-1.772-.829,1.623,1.623,0,0,1-.534-1.267,1.669,1.669,0,0,1,.682-1.414,3.061,3.061,0,0,1,1.874-.517,2.894,2.894,0,0,1,1.676.466,2.371,2.371,0,0,1,.937,1.3,1.371,1.371,0,0,1-.812.335.443.443,0,0,1-.273-.074.835.835,0,0,1-.2-.256,1.37,1.37,0,0,0-1.323-.818c-.841,0-1.267.3-1.267.892a.9.9,0,0,0,.119.483,1.04,1.04,0,0,0,.426.341,6.634,6.634,0,0,0,.892.335,10.057,10.057,0,0,1,1.579.6,2.055,2.055,0,0,1,.761.608,1.473,1.473,0,0,1,.222.835,2.02,2.02,0,0,1-.346,1.176,2.239,2.239,0,0,1-.977.8,3.6,3.6,0,0,1-1.471.284A4.624,4.624,0,0,1,414.744,246.345Z",
    transform: "translate(-391.37 -239.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17631",
    "data-name": "Path 17631",
    d: "M438.371,239.815a.69.69,0,0,1-.108.432.4.4,0,0,1-.329.136h-1.517v6.14h-1.272v-6.14H433.23v-.943h5.1A1.741,1.741,0,0,1,438.371,239.815Z",
    transform: "translate(-399.892 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17632",
    "data-name": "Path 17632",
    d: "M471.523,239.44l-2.215,4.107v2.977h-1.272v-2.977l-2.215-4.107h1.335l1.528,2.976,1.517-2.976Z",
    transform: "translate(-413.97 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17633",
    "data-name": "Path 17633",
    d: "M486.875,245.587a4.169,4.169,0,0,1-.8-2.715,4,4,0,0,1,.8-2.658,3.114,3.114,0,0,1,4.465,0,4,4,0,0,1,.8,2.658,4.169,4.169,0,0,1-.8,2.715,3.063,3.063,0,0,1-4.465,0Zm3.522-.659a3.958,3.958,0,0,0,.42-2.056,3.758,3.758,0,0,0-.415-2.005,1.636,1.636,0,0,0-2.59,0,3.744,3.744,0,0,0-.415,2.005,3.931,3.931,0,0,0,.42,2.056,1.583,1.583,0,0,0,2.579,0Z",
    transform: "translate(-422.722 -239.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17634",
    "data-name": "Path 17634",
    d: "M508.13,243.984V239.44h1.284v4.726a1.531,1.531,0,0,0,.386,1.13,1.562,1.562,0,0,0,1.13.381,1.53,1.53,0,0,0,1.136-.375,1.556,1.556,0,0,0,.369-1.13v-4.726h1.284v4.544a2.611,2.611,0,0,1-.687,1.994,2.975,2.975,0,0,1-2.1.648Q508.127,246.623,508.13,243.984Z",
    transform: "translate(-432.247 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17635",
    "data-name": "Path 17635",
    d: "M535.352,246.417a.882.882,0,0,1-.3.131,1.754,1.754,0,0,1-.426.051,1,1,0,0,1-.454-.085.553.553,0,0,1-.25-.29l-.892-1.778a1.3,1.3,0,0,0-.437-.534,1.361,1.361,0,0,0-.7-.148h-.579v2.749H530.03V239.43H532.4a3.172,3.172,0,0,1,2.022.568,1.921,1.921,0,0,1,.716,1.6,1.9,1.9,0,0,1-.369,1.176,2.1,2.1,0,0,1-1.045.721,2.645,2.645,0,0,1,.466.659Zm-3.033-3.59a1.842,1.842,0,0,0,1.153-.3,1.109,1.109,0,0,0,.375-.926,1.12,1.12,0,0,0-.363-.926,1.794,1.794,0,0,0-1.142-.3h-1.023v2.448Z",
    transform: "translate(-441.707 -239.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17636",
    "data-name": "Path 17636",
    d: "M570.173,246.488a1.93,1.93,0,0,1-.818.131.979.979,0,0,1-.42-.074.607.607,0,0,1-.256-.239l-1.409-2.283a2.59,2.59,0,0,0-.3-.409.616.616,0,0,0-.3-.17,2.116,2.116,0,0,0-.489-.045H566v3.136H564.72V239.45H566v3.045h.6l2.1-3.045h1.386l-2.4,3.368a2.8,2.8,0,0,1,.761.858Z",
    transform: "translate(-456.692 -239.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17637",
    "data-name": "Path 17637",
    d: "M590.754,245.871c.011.187.023.312.023.375,0,.182-.085.273-.261.273h-1.039V246.1a2.166,2.166,0,0,0-.392-1.125l-2.607-3.772v5.311H585.21v-7.083h1.125a.542.542,0,0,1,.21.034.455.455,0,0,1,.17.165l2.761,3.965V239.43h1.267v5.7C590.737,245.343,590.743,245.587,590.754,245.871Z",
    transform: "translate(-465.543 -239.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17638",
    "data-name": "Path 17638",
    d: "M607.1,245.587a4.17,4.17,0,0,1-.8-2.715,4,4,0,0,1,.8-2.658,3.114,3.114,0,0,1,4.465,0,4,4,0,0,1,.8,2.658,4.17,4.17,0,0,1-.8,2.715,3.063,3.063,0,0,1-4.465,0Zm3.516-.659a3.96,3.96,0,0,0,.42-2.056,3.759,3.759,0,0,0-.415-2.005,1.636,1.636,0,0,0-2.59,0,3.745,3.745,0,0,0-.415,2.005,3.93,3.93,0,0,0,.42,2.056,1.583,1.583,0,0,0,2.579,0Z",
    transform: "translate(-474.654 -239.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M635.828,239.44a29.841,29.841,0,0,1-1.642,7.083h-1.363q-.554-1.747-.818-2.71c-.176-.642-.324-1.3-.443-1.971-.136.75-.3,1.46-.477,2.136s-.443,1.522-.778,2.55h-1.363a31.712,31.712,0,0,1-1.079-3.437,33.234,33.234,0,0,1-.665-3.641h1.267c.136,1.2.284,2.193.437,2.976s.4,1.693.716,2.727c.278-.835.505-1.625.693-2.357s.437-1.852.756-3.346h.96q.6,2.59.863,3.6t.613,2.1a26.824,26.824,0,0,0,.676-2.681c.148-.784.284-1.789.415-3.016h1.233Z",
    transform: "translate(-483.682 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M657.619,245.6v.92H653.45V239.44h1.284V245.6Z",
    transform: "translate(-495.021 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17641",
    "data-name": "Path 17641",
    d: "M676.052,245.6a1.6,1.6,0,0,1-.114.727.431.431,0,0,1-.415.193H671.61V239.44h4.363v.92h-3.085v2.062h2.6v.909h-2.6V245.6h3.164Z",
    transform: "translate(-502.866 -239.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17642",
    "data-name": "Path 17642",
    d: "M695.643,240.367a3.606,3.606,0,0,1,.9,2.607,3.96,3.96,0,0,1-.415,1.869,2.967,2.967,0,0,1-1.176,1.233,3.576,3.576,0,0,1-1.795.437H690.86V239.43h2.295A3.328,3.328,0,0,1,695.643,240.367Zm-.971,4.561a2.889,2.889,0,0,0,.579-1.937q0-2.633-2.244-2.63h-.881V245.6h.881A2.1,2.1,0,0,0,694.672,244.928Z",
    transform: "translate(-511.181 -239.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17643",
    "data-name": "Path 17643",
    d: "M717.63,242.6v3.107a2.809,2.809,0,0,1-1.068.625,4.357,4.357,0,0,1-1.4.21,3.145,3.145,0,0,1-2.454-.92,3.929,3.929,0,0,1-.835-2.721,4.377,4.377,0,0,1,.4-1.943,2.948,2.948,0,0,1,1.165-1.261,3.482,3.482,0,0,1,1.789-.437,4.193,4.193,0,0,1,1.369.21,2.381,2.381,0,0,1,.994.608,1.522,1.522,0,0,1-.278.494c-.125.148-.233.222-.329.222a.571.571,0,0,1-.3-.114,2.287,2.287,0,0,0-.7-.364,2.6,2.6,0,0,0-.778-.114,1.758,1.758,0,0,0-1.505.687,3.287,3.287,0,0,0-.517,2.005q0,2.692,1.965,2.692a2.809,2.809,0,0,0,.716-.085,1.251,1.251,0,0,0,.494-.227v-1.761h-.892a.406.406,0,0,1-.392-.2,1.621,1.621,0,0,1-.114-.716h2.67Z",
    transform: "translate(-520.257 -239.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17644",
    "data-name": "Path 17644",
    d: "M737.992,245.6a1.6,1.6,0,0,1-.114.727.431.431,0,0,1-.415.193H733.55V239.44h4.363v.92h-3.084v2.062h2.6v.909h-2.6V245.6h3.164Z",
    transform: "translate(-529.622 -239.332)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2926",
    "data-name": "Group 2926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2918",
    "data-name": "Group 2918",
    transform: "translate(64.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17645",
    "data-name": "Path 17645",
    d: "M238.716,65.145,210.377,81.5,206.06,84l4.317,2.494L234.4,100.362l4.317-2.494,29.055-16.774L239.432,64.73Z",
    transform: "translate(-206.06 -64.73)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2919",
    "data-name": "Group 2919",
    transform: "translate(62.739 18.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17646",
    "data-name": "Path 17646",
    d: "M203.23,97.88l4.5,2.585,25.124,14.4,4.453-2.567Z",
    transform: "translate(-203.23 -97.88)",
    fill: "#2e3192"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2920",
    "data-name": "Group 2920",
    transform: "translate(2.641 1.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17647",
    "data-name": "Path 17647",
    d: "M159.135,85.419l-4.317-2.494L131.807,69.639a12.07,12.07,0,0,0-12.076,0L97.43,82.516l29.049,16.768,4.317,2.494,24.022,13.866,4.317,2.494,4.317-2.494,24.022-13.871L163.452,87.9Z",
    transform: "translate(-97.43 -68.02)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2921",
    "data-name": "Group 2921",
    transform: "translate(68.504 75.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17648",
    "data-name": "Path 17648",
    d: "M241.781,235.976l.131-32.718.017-4.987-4.328,2.477-24.073,13.775-.017,4.987-.131,33.548,28.4-16.251Z",
    transform: "translate(-213.38 -198.27)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2922",
    "data-name": "Group 2922",
    transform: "translate(68.629 74.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17649",
    "data-name": "Path 17649",
    d: "M243.211,196.22l-4.5,2.59-25.09,14.462-.023,5.135Z",
    transform: "translate(-213.6 -196.22)",
    fill: "#2e3192"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17650",
    "data-name": "Path 17650",
    d: "M242.046,158.835l4.328-2.477,23.062-13.2a12.074,12.074,0,0,0,6.078-10.435l.1-25.749L246.5,123.64l-4.328,2.477L218.1,139.892l-4.328,2.477-.017,4.987-.108,27.737,24.073-13.775Z",
    transform: "translate(-144.992 -82.981)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2923",
    "data-name": "Group 2923",
    transform: "translate(33.57 75.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17651",
    "data-name": "Path 17651",
    d: "M152.022,235.976l-.125-32.718-.017-4.987,4.323,2.477,24.079,13.775.017,4.987.131,33.548-28.4-16.251Z",
    transform: "translate(-151.88 -198.27)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2924",
    "data-name": "Group 2924",
    transform: "translate(32.383 74.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17652",
    "data-name": "Path 17652",
    d: "M149.79,196.22l4.5,2.59,25.084,14.462.023,5.135Z",
    transform: "translate(-149.79 -196.22)",
    fill: "#2e3192"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2925",
    "data-name": "Group 2925",
    transform: "translate(0 23.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17653",
    "data-name": "Path 17653",
    d: "M126.351,158.835l-4.328-2.477-23.062-13.2a12.074,12.074,0,0,1-6.078-10.435l-.1-25.749,29.111,16.66,4.328,2.477,24.073,13.775,4.328,2.477.017,4.987.108,27.737-24.073-13.775Z",
    transform: "translate(-92.78 -106.98)",
    fill: "url(#linear-gradient-6)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogo);
export default __webpack_public_path__ + "static/media/applogo.b4cb26f5e8c7cc15df5ff917a6b7f442.svg";
export { ForwardRef as ReactComponent };